<template>
  <div v-if="editprofile">
    <v-dialog max-width="600" v-model="editprofile" class="elevation-0 rounded-0" persistent>
      <v-card   ref="form" class="elevation-0 rounded-0">
        <v-toolbar elevation="0" color="#F7F7F7" dense >
          <v-toolbar-title>Edit Profile</v-toolbar-title>

          <v-spacer></v-spacer>
          <v-btn
          class="elevation-0 rounded-0" small color="primary"
            v-if="editprofdata && editprofdata.sameUser != true"
            @click="setEditPass(true), fetchEditPass(editprofdata.user.id)"
            
          >
            <v-icon small>mdi-lock-outline</v-icon>
            &nbsp; Password
          </v-btn>
          &nbsp;
          <v-btn class="elevation-0 rounded-0 ml-2" small color="primary" @click="fetchApiData(editprofdata.user.id),fetchDataApi(editprofdata.user.id)">
            <v-icon small>mdi-cog-outline</v-icon>
            &nbsp; Api Access
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-container style="margin-top:0"  v-if="!editprofdata" fill-height fluid>
        <v-row align="center" justify="center">
          <v-col
            ><img
              alt="Navplus logo"
              width="70px"
              :src="loadernavplus"
              class="justify-center"
          /></v-col>
        </v-row>
      </v-container>
        <div v-if="editprofdata">
        <v-progress-linear
          v-if="!editprofdata"
          indeterminate
          color="cyan"
        ></v-progress-linear>
        <v-card-text
          v-if="editprofdata"
          style="margin-top: 55px; margin-bottom: -50px"
        >
          <v-text-field
          class="elevation-0 rounded-0"
            :rules="rules"
            maxlength="25"
            counter
            hint="Name should be 25 character max"
            :value="editprofdata.user.name"
            label="Name"
            v-model="editprofdata.user.name"
            outlined
          ></v-text-field>
          <v-text-field
          class="elevation-0 rounded-0"
            :rules="rules"
            maxlength="25"
            counter
            hint="Username should be 25 character max"
            :value="editprofdata.user.username"
            label="Username"
            v-model="editprofdata.user.username"
            outlined
          ></v-text-field>

          <v-text-field
            :value="editprofdata.user.email"
            label="Email"
            class="elevation-0 rounded-0"
            disabled
            outlined
          ></v-text-field>

          <v-divider class="mt-12"></v-divider>
        </v-card-text>
        <v-card-actions style="margin-top: 2em">
          <v-btn
          small
          class="elevation-0 rounded-0"
            v-if="editprofdata"
            color="primary"
            @click="
              editprofdata.user.name == '' || editprofdata.user.username == ''
                ? (eprof_empty = true)
                : editprofdata.user.name != userprof.name ||
                  editprofdata.user.username != userprof.username
                ? (eprof_confirm = true)
                : (eprof_nochange = true)
            "
            style="width: 49%"
            dark
          >
            Update Profile
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
          small
          class="elevation-0 rounded-0"
            color="red"
            @click="removeEditProf(null)"
            style="width: 49%"
            dark
          >
            cancel
          </v-btn>
        </v-card-actions>
      </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="eprof_confirm" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Are you sure? </v-card-title>
        <v-card-text style="text-align: left"
          >Profile data will updated after you click yes</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="eprof_confirm = false">
            No
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="
              EditProfileSubmit(), (dialog = true), (eprof_confirm = false)
            "
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="eprof_nochange" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> No Changes! </v-card-title>
        <v-card-text style="text-align: left"
          >You did not change anything</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="eprof_nochange = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="eprof_empty" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Empty Input! </v-card-title>
        <v-card-text style="text-align: left"
          >Name and username cannot empty</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="eprof_empty = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card color="#4CAF50" style="padding: 1em" dark>
        <v-alert dense prominent type="success" style="margin-top: 1em"
          >Profile has change</v-alert
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["user_id_bawaan"],
  data() {
    return {
      loadernavplus: require("@/assets/img/load100new.gif"),
      dialog: false,
      eprof_confirm: null,
      eprof_nochange: null,
      eprof_empty: null,
    };
  },

  watch: {
    dialog(val) {
      if (!val) return;

      setTimeout(() => (this.dialog = false), 1000);
    },
  },

  async created() {
    this.fetchUserData(localStorage.getItem("token"));
  },

  destroyed() {
    this.removeEditProf(null);
  },

  methods: {
    ...mapActions([
      "removeEditProf",
      "setUserChange",
      "setNameChange",
      "setProfileChange",
      "fetchUserData",
      "setuserSaveData",
      "setEditPass",
      "fetchEditPass",
      "fetchApiData",
      "addDataApi",
      "fetchDataApi"
    ]),
    created() {
      this.fetchUserData(localStorage.getItem("token"));
    },

    async EditProfileSubmit() {
      const data = {
        name: this.editprofdata.user.name,
        username: this.editprofdata.user.username,
      };
      const response = await axios.post(
        "https://navigatorplus.sailink.id/api/v1/navplus/user/edit/" +
          this.editprofdata.user.id,
        data,
        {
          headers: {
            Authorization: "Bearer" + localStorage.getItem("token"),
          },
        }
      );
      console.log(response);
      console.log(this.editprofdata);
      if (this.editprofdata.sameUser == true) {
        this.fetchUserData();
      } else {
        this.fetchAdmin(localStorage.getItem("token"));
      }
      this.removeEditProf(null);
    },
  },
  computed: {
    ...mapGetters([
      "editprofile",
      "username_change",
      "name_change",
      "profile_change",
      "userprof",
      "userSave",
      "editprofdata",
    ]),
  },
};
</script>

<style lang="scss" scoped></style>
